import {MessageStatusType} from '@core/api/data-access';
import {DcIconStruct} from '@shared-types';

export type MessageStatusStruct = {
	status: MessageStatusType;
	label: string; // the translated label of the status
	colors: {
		// The color of the status is stored in the color property, and the lighten color is stored in the lighten property.'green'
		color: string; // the color of the status
		lighten: string; // the lighten color of the status
	};
	icon: DcIconStruct; // the icon that represents the status
};

export function getMessageStatusStruct(status: MessageStatusType): MessageStatusStruct {
	switch (status) {
		case MessageStatusType.Unknown:
			return {
				status: MessageStatusType.Unknown,
				label: 'struct.flowchart.message.unknown',
				colors: {color: 'rgba(96, 125, 139, 1)', lighten: 'rgba(96, 125, 139, 0.2)'},
				icon: {
					name: 'messages-question',
					type: 'duotone',
					size: 'lg',
					primaryColor: 'orange',
					secondaryColor: '#FFC400',
				},
			};
		case MessageStatusType.Queued:
			return {
				status: MessageStatusType.Queued,
				label: 'struct.flowchart.message.unknown',
				colors: {color: 'rgba(3, 169, 244, 1)', lighten: 'rgba(3, 169, 244, 0.2)'},
				icon: {
					name: 'messages-question',
					type: 'duotone',
					size: 'lg',
					primaryColor: 'orange',
					secondaryColor: '#FFC400',
				},
			};
		case MessageStatusType.Sent:
			return {
				status: MessageStatusType.Sent,
				label: 'struct.flowchart.message.sent',
				colors: {color: 'rgb(246,156,52)', lighten: 'rgba(139, 195, 74, 0.2)'},
				icon: {
					name: 'check',
					type: 'solid',
					size: 'lg',
					primaryColor: 'green',
					secondaryColor: 'green',
				},
			};
		case MessageStatusType.Received:
			return {
				status: MessageStatusType.Received,
				label: 'struct.flowchart.message.recieved',
				colors: {color: 'rgba(139, 195, 74, 1)', lighten: 'rgba(139, 195, 74, 0.2)'},
				icon: {
					name: 'check-double',
					type: 'solid',
					size: 'lg',
					primaryColor: 'green',
					secondaryColor: 'green',
				},
			};
		case MessageStatusType.Error:
			return {
				status: MessageStatusType.Error,
				label: 'struct.flowchart.message.error',
				colors: {color: 'rgba(244, 67, 54, 1)', lighten: 'rgba(244, 67, 54, 0.2)'},
				icon: {
					name: 'message-exclamation',
					type: 'duotone',
					size: 'lg',
					primaryColor: 'red',
					secondaryColor: '#FF847F',
				},
			};
		default:
			return {
				status: MessageStatusType.Unknown,
				label: 'struct.flowchart.message.unknown',
				colors: {color: 'rgba(96, 125, 139, 1)', lighten: 'rgba(96, 125, 139, 0.2)'},
				icon: {
					name: 'messages-question',
					type: 'duotone',
					size: 'lg',
					primaryColor: 'orange',
					secondaryColor: '#FFC400',
				},
			};
	}
}
